export default function initializeLazyYoutube() {
    document.querySelectorAll('.lazy-youtube').forEach(function (video) {
        new LazyYoutube(video);
    });
}

class LazyYoutube {
    constructor(video) {
        this.video = video;
        this.init();
    }

    init() {
        this.convertLinkToVideoId();
        // Przygotowanie preview
        this.preparePreview();
        this.clickToLoad();
    }

    convertLinkToVideoId() {
        const youtubeLink = this.video.dataset.youtube_link;
        let videoId = youtubeLink.split('v=')[1];
        if(!videoId) {
            videoId = youtubeLink.split('.be/')[1];
        }
        videoId = videoId.split('?')[0];
        this.video.dataset.video_id = videoId;
    }

    preparePreview() {
        const preview = document.createElement('div');
        preview.classList.add('lazy-youtube__preview');

        const hqdefault = `https://img.youtube.com/vi/${this.video.dataset.video_id}/hqdefault.jpg`;
        const maxresdefault = `https://img.youtube.com/vi/${this.video.dataset.video_id}/maxresdefault.jpg`;

        //  maxresdefault nie zawsze istnieje więc wtedy używamy hqdefault
        const img = new Image();
        img.src = maxresdefault;
        img.onload = () => {
            if(img.width > 120 && img.height > 90) {
                preview.style.backgroundImage = `url(${maxresdefault})`;
            }
            else {
                preview.style.backgroundImage = `url(${hqdefault})`;
            }
        };

        img.onerror = () => {
            preview.style.backgroundImage = `url(${hqdefault})`;
        };

        preview.addEventListener('click', () => {
            this.loadVideo();
        });
        this.video.appendChild(preview);
    }

    clickToLoad() {
        this.video.addEventListener('click', () => {
            this.loadVideo();
        });
    }

    loadVideo() {
        const iframe = document.createElement('iframe');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('src', `https://www.youtube.com/embed/${this.video.dataset.video_id}?autoplay=1`);
        this.video.innerHTML = '';
        this.video.appendChild(iframe);
    }
}